const offline = ref(false);

if (typeof globalThis !== "undefined") {
  globalThis.addEventListener(
    "load",
    function () {
      offline.value = !navigator.onLine;
    },
    false,
  );

  globalThis.addEventListener(
    "online",
    function () {
      offline.value = false;
    },
    false,
  );

  globalThis.addEventListener(
    "offline",
    function () {
      offline.value = true;
    },
    false,
  );
}

export { offline };
